import Axios from 'axios';

const API_URL =  process.env.API_URL + '/api/v3/data/products/sub-categories';

class SubProductCategory {
  index() {
    return Axios.get(API_URL);
  }

  show(subcategory) {
    return Axios.get(API_URL + `/${subcategory}`);
  }
}

export default new SubProductCategory();



// WEBPACK FOOTER //
// ./src/api/subproductcategoryv3.js